module.exports = __webpack_public_path__ + "img/11.b2f103e8.jpg";